<template>
  <div>
    <div class="job">
      <h2 style="color: black;font-size: 36px">精选兼职</h2>
      <a style="color: black;font-size: 22px;font-weight: bold;text-align: right;margin-right: 20%"
         @click="showQrcode()">查看更多></a>
      <div style="display: flex; flex-direction: column">
        <div v-for="item in jobPageData" :key="item.id" class="item">
          <div style="display: flex; flex-direction: row">
            <div style="display: flex; flex-direction: column">
              <div class="itemTitle">{{ item.title }}</div>
              <div style="font-size: 16px;margin-top: 30px;color: #101010;align-items: center;justify-content: center">
                {{ getTag(item) }}
              </div>
            </div>
            <div style="display: flex; flex-direction: row;margin-left: auto;align-items: center">
              <div style="font-size: 16px;color: #FC8E0B;font-weight: bold">{{ item.salaryRange }}</div>
              <Button class="btn" @click="showQrcode()">
                报名
              </Button>
            </div>
          </div>
        </div>
      </div>
      <CenterDialog
        :visible.sync="show"
        type="image"
        width="240px"
        title="请前往小程序继续操作"
        :image="imageQrcode"
        :showActions="false"
      />
    </div>
  </div>
</template>

<script>

import api from "@/api";
import CenterDialog from "@/views/toc/ShowImageDialog.vue";

export default {
  name: 'ShowJob',
  components: {CenterDialog},
  created() {
    this.getJobData();
  },
  data() {
    return {
      jobPageData: [],
      show: false,
      imageQrcode: require('@/assets/img/qrcode.jpg'),
    }
  },
  methods: {
    getJobData() {
      api.statistics
        .getJobData({
          'limit': 5,
          "page": 1,
          "area": [],
          "settleType": [],
          "city": "北京",
          "orderBy": [
            {
              field: 'settleType',
              sort: 'asc'
            }
          ]
        })
        .then(res => {
          this.jobPageData = res.data.records;
        })
        .catch(error => {
          console.error('请求出错：', error)
        })
    },
    getTag(item) {
      let tag = ""
      if (item.scene === "1") {
        tag = "不限区域"
      } else if (item.city && item.area) {
        tag = item.area + item.area
      } else {
        tag = item.addressDetail
      }
      if (item.firstTagName && item.firstTagName !== "") {
        tag = tag + "|" + item.firstTagName
      }
      return tag
    },
    showQrcode() {
      this.show = true
    }
  }
};
</script>
<style scoped>
.job {
  padding: 60px 0 60px 0;
  text-align: center;
  background-color: #F6F7FB;
  display: flex;
  flex-direction: column;
}

.item {
  text-align: left;
  margin-left: 20%;
  margin-right: 20%;
  padding: 13px 30px;
  background: white;
  border: 1px solid #EFEFEF;
  border-radius: 5px;
  margin-top: 28px;
}

.itemTitle {
  color: #101010;
  font-size: 18px;
  font-weight: bold;
}

.btn {
  margin-left: 28px;
  color: white;
  background: #FC8E0B;
  font-size: 16px;
  font-weight: bold;
  border-radius: 20px;
  border: none;
}
</style>
